import { APIService } from "./apiService";

abstract class BaseService<T extends APIService> {
  protected readonly apiService: T;

  constructor(apiService: T) {
    this.apiService = apiService;
  }
}

export { BaseService };
